import { Button, Table, TableSorting } from 'AWS-UI-Components-React';
import React from 'react';
import { COMPONENT_NAMES } from '../../../constants/asin_metric_elements';
import { downloadFile, extractErrorMessage, toDownloadFormat } from '../../../utilities';
import { formatTimeFrameToYYYYMM, YYYYMMDDToDate } from '../../../utils/date-utils';
import { EmptyMessage } from '../../content/empty_message';
import { OPERATION_STATUS, TEXT } from '../common/constants';
import { getColumnDefinitions } from './asin_metrics_utils';
import logger from '../../../utils/logging';

export class GlMetricTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadStatus: OPERATION_STATUS.NONE,
    };
  }

  onDownloadData = () => {
    const {items, displayInMillions, payload, latestSnapshot} = this.props;
    this.setState({ downloadStatus: OPERATION_STATUS.IN_PROGRESS });
    const month = formatTimeFrameToYYYYMM(payload.timeFrame);
    try {
      const formattedItems
        = items.map(item => ({...item, component: COMPONENT_NAMES[item.component] || item.component }));
      const data = toDownloadFormat(getColumnDefinitions(items, displayInMillions), formattedItems);
      downloadFile(data, `GL_Metrics_${month}_As_of_${YYYYMMDDToDate(latestSnapshot)}.xls`);
      this.setState({ downloadStatus: OPERATION_STATUS.SUCESS });
    } catch (error) {
      logger.error(extractErrorMessage(error), error);
      this.setState({downloadStatus: OPERATION_STATUS.FAIL});
    }
  };

  render() {
    const {tableName, items, loading, displayInMillions, downloadEnabled} = this.props;
    const empty = !items || !items.length;
    const sortableColumns = [
      { id: "NET_FA", field: "NET_FA" },
      { id: "NET_LA", field: "NET_LA" },
      { id: "NET_VAR_PER_UNIT", field: "NET_VAR_PER_UNIT" },
      { id: "ABS_VAR_PER_UNIT", field: "ABS_VAR_PER_UNIT" },
      { id: "WINSORIZED_NET_VAR_PER_UNIT", field: "WINSORIZED_NET_VAR_PER_UNIT" },
      { id: "WINSORIZED_ABS_VAR_PER_UNIT", field: "WINSORIZED_ABS_VAR_PER_UNIT" }];

    return (
      <div style={{marginTop: '1.5em'}}>
        <Table
          className="ZebraStripesTable accuracy-table-container"
          columnDefinitions={getColumnDefinitions(items, displayInMillions)}
          items={items}
          loadingText={TEXT.LOADING}
          loading={loading}
          wrapLines={false}
          empty={<EmptyMessage />}
          header={
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title">
                <h4>{tableName}</h4>
              </div>
              { downloadEnabled &&
              <div className="awsui-util-action-stripe-group">
                <Button
                  text="Download"
                  variant="normal"
                  onClick={this.onDownloadData}
                  disabled={loading || empty}
                  loading={this.state.downloadStatus === OPERATION_STATUS.IN_PROGRESS}
                  data-cy="asin-all-components-download"
                />
              </div>
              }
            </div>
          }>
          <TableSorting sortingDescending={true}
                        sortableColumns={sortableColumns} />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/gl_metric_table.jsx